(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-information"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.mlap-pdp');

  sections.forEach(function(section) {
    var sectionId = section.dataset.sectionId;

    // ── Gallery ──────────────────────────
    var slides  = section.querySelectorAll('[data-slide]');
    var thumbs  = section.querySelectorAll('[data-thumb]');
    var prevBtn = section.querySelector('[data-gallery-prev]');
    var nextBtn = section.querySelector('[data-gallery-next]');
    var counter = section.querySelector('[data-current]');
    var current = 0;

    function goTo(n) {
      if (!slides.length) return;
      slides[current].classList.remove('is-active');
      thumbs[current] && thumbs[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      thumbs[current] && thumbs[current].classList.add('is-active');
      if (counter) counter.textContent = current + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    thumbs.forEach(function(t) {
      t.addEventListener('click', function() { goTo(parseInt(t.dataset.thumb)); });
    });

    // Keyboard nav
    section.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Touch swipe
    var touchStartX = 0;
    var stage = section.querySelector('[data-gallery]');
    if (stage) {
      stage.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    // ── Quantity ─────────────────────────
    var qtyInput = section.querySelector('.mlap-pdp__qty-input');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        if (qtyInput && parseInt(qtyInput.value) > 1) {
          qtyInput.value = parseInt(qtyInput.value) - 1;
        }
      });
    }
    
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        if (qtyInput) {
          qtyInput.value = parseInt(qtyInput.value) + 1;
        }
      });
    }

    // ── Wishlist toggle ───────────────────
    var wishBtn = section.querySelector('[data-wishlist]');
    if (wishBtn) {
      wishBtn.addEventListener('click', function() {
        this.classList.toggle('is-wishlisted');
        var svg = this.querySelector('svg path');
        if (svg) {
          if (this.classList.contains('is-wishlisted')) {
            svg.style.fill = '#b8304a';
            svg.style.stroke = '#b8304a';
          } else {
            svg.style.fill = 'none';
            svg.style.stroke = 'currentColor';
          }
        }
      });
    }

    // ── VARIANT PICKER - FIXED ────────────────────
    var variantInputs = section.querySelectorAll('[data-option-index]');
    var hiddenInput   = section.querySelector('#mlap-variant-input-' + sectionId);
    var priceEl       = section.querySelector('#mlap-price-' + sectionId);
    var comparePriceEl = section.querySelector('.mlap-pdp__price-compare');
    var atcBtn        = section.querySelector('#mlap-atc-' + sectionId);
    var atcText       = atcBtn ? atcBtn.querySelector('.mlap-pdp__atc-text') : null;
    
    // Get stock badge
    var stockBadge = null;
    var badges = section.querySelectorAll('.mlap-pdp__badge');
    badges.forEach(function(badge) {
      if (badge.classList.contains('mlap-pdp__badge--green') || badge.classList.contains('mlap-pdp__badge--gray')) {
        stockBadge = badge;
      }
    });
    
    // Get sale badge
    var saleBadge = section.querySelector('.mlap-pdp__badge--amber');

    // Get product variants from the JSON data we added
    var variants = [];
    var productJson = section.querySelector('[data-product-json]');
    
    if (productJson) {
      try {
        var productData = JSON.parse(productJson.innerHTML);
        variants = productData.variants || [];
        window.moneyFormat = productData.money_format || '₹{{amount}}';
      } catch(e) {
        console.error('Could not parse product JSON', e);
      }
    }

    // Function to find matching variant
    function findMatchingVariant() {
      if (!variants.length) return null;

      // Get all option groups
      var optionGroups = section.querySelectorAll('.mlap-pdp__option-group');
      var selectedOptions = [];
      
      // For each option group, find the selected value
      optionGroups.forEach(function(group, index) {
        var selectedInput = group.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          selectedOptions[index] = selectedInput.value;
        }
      });

      // Find variant that matches all selected options
      return variants.find(function(variant) {
        var match = true;
        
        if (selectedOptions[0] !== undefined) {
          match = match && (variant.option1 === selectedOptions[0]);
        }
        if (selectedOptions[1] !== undefined) {
          match = match && (variant.option2 === selectedOptions[1]);
        }
        if (selectedOptions[2] !== undefined) {
          match = match && (variant.option3 === selectedOptions[2]);
        }
        
        return match;
      });
    }

    // Format money function
    function formatMoney(amount) {
      // amount is in cents, convert to dollars/rupees
      var value = amount / 100;
      
      // Use Shopify's format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(amount, window.moneyFormat || '₹{{amount}}');
      }
      
      // Simple fallback formatting
      return '₹' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Function to update UI based on selected variant
    function updateVariantUI() {
      var variant = findMatchingVariant();
      
      if (variant && hiddenInput) {
        // Update hidden input with variant ID
        hiddenInput.value = variant.id;
        
        // Update price
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
        
        // Update compare at price if exists
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = 'inline';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        
        // Update add to cart button
        if (atcBtn && atcText) {
          var isAvailable = variant.available;
          atcBtn.disabled = !isAvailable;
          atcText.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
        }

        // Update stock badge
        if (stockBadge) {
          if (variant.available) {
            stockBadge.className = 'mlap-pdp__badge mlap-pdp__badge--green';
            stockBadge.textContent = 'In Stock';
          } else {
            stockBadge.className = 'mlap-pdp__badge mlap-pdp__badge--gray';
            stockBadge.textContent = 'Out of Stock';
          }
        }

        // Update sale badge
        if (saleBadge) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            saleBadge.textContent = 'Save ' + savings + '%';
            saleBadge.style.display = 'inline';
          } else {
            saleBadge.style.display = 'none';
          }
        }

        // Trigger custom event for other components
        section.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { variant: variant }
        }));
        
        console.log('Variant updated:', variant);
      }
    }

    // Add change event listeners to all variant inputs
    if (variantInputs.length && hiddenInput && variants.length) {
      variantInputs.forEach(function(input) {
        input.addEventListener('change', function(e) {
          updateVariantUI();
        });
      });

      // Initial update on page load
      setTimeout(updateVariantUI, 100);
    }

    // ── Share ─────────────────────────────
    var shareBtn = section.querySelector('[data-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: window.location.href
          });
        } else {
          navigator.clipboard.writeText(window.location.href).then(function() {
            var originalContent = shareBtn.innerHTML;
            shareBtn.innerHTML = 'Copied!';
            setTimeout(function() { 
              shareBtn.innerHTML = originalContent;
            }, 2000);
          });
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-animate]').forEach(function(el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('[data-section-id]').forEach(function (section) {

    var track    = section.querySelector('[data-track]');
    var dotsWrap = section.querySelector('[data-dots]');

    if (!track) return;

    var current = 0;
    var cards   = Array.from(track.children);
    var total   = cards.length;

    function getCols () {
      return parseFloat(getComputedStyle(track).getPropertyValue('--cols')) || 6;
    }
    function getGap () {
      return parseInt(getComputedStyle(track).getPropertyValue('--gap')) || 16;
    }
    function getCardWidth () {
      var cols   = getCols();
      var gap    = getGap();
      var trackW = track.parentElement.clientWidth - 8;
      return (trackW - gap * (cols - 1)) / cols;
    }
    function getMaxIndex () {
      return Math.max(0, total - Math.floor(getCols()));
    }

    /* ── Dots ─────────────────────── */
    function buildDots () {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = getMaxIndex() + 1;
      if (pages <= 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = 'flex';
      for (var p = 0; p < pages; p++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.className = 'mlap-plist__dot' + (idx === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Slide ' + (idx + 1));
          btn.addEventListener('click', function () { goTo(idx); });
          dotsWrap.appendChild(btn);
        })(p);
      }
    }

    function updateDots () {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.mlap-plist__dot');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    /* ── Navigate ─────────────────── */
    function goTo (idx) {
      current = Math.max(0, Math.min(idx, getMaxIndex()));
      var offset = current * (getCardWidth() + getGap());
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateDots();
    }

    /* ── Keyboard ─────────────────── */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    /* ── Drag / swipe ─────────────── */
    var startX = 0, delta = 0, dragging = false;

    track.addEventListener('mousedown', function (e) {
      startX = e.clientX; dragging = true;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (dragging) delta = e.clientX - startX;
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (delta < -60)      goTo(current + 1);
      else if (delta > 60)  goTo(current - 1);
      delta = 0;
    });
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (diff >  60) goTo(current + 1);
      if (diff < -60) goTo(current - 1);
    }, { passive: true });

    /* ── Resize ───────────────────── */
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        buildDots();
        goTo(Math.min(current, getMaxIndex()));
      }, 150);
    });

    /* ── Init ─────────────────────── */
    buildDots();
    goTo(0);

    /* ── Wishlist ─────────────────── */
    section.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        this.classList.toggle('is-active');
        var path = this.querySelector('path');
        if (this.classList.contains('is-active')) {
          path.style.fill = '#b8304a'; path.style.stroke = '#b8304a';
        } else {
          path.style.fill = 'none'; path.style.stroke = 'currentColor';
        }
      });
    });

    /* ── Quick Add feedback ───────── */
    section.querySelectorAll('.mlap-card__cta-btn--secondary').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.disabled) return;
        var orig = this.innerHTML;
        this.innerHTML = '✓ Added!';
        this.style.background = 'rgba(255,255,255,0.35)';
        var self = this;
        setTimeout(function () { self.innerHTML = orig; self.style.background = ''; }, 1800);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('[data-reveal]');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        var delay = e.target.dataset.revealDelay || 0;
        setTimeout(function() {
          e.target.classList.add('is-visible');
        }, parseInt(delay));
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function(el) { observer.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
